<template>
  <div>
    <div class="row pb-3">
      <div class="col-md-7 col-sm-12">
        <h4 class="font-weight-bold">Identificação da Pessoa</h4>
      </div>
      <!-- <div class="col-md-5 col-sm-12 pr-0">
				<form-select
					v-model="item.estado_cadastral_cadunico"
					:itens="$root.arrays.estado_cadastral"
					@change="item.estado_cadastral_cadunico == 4 ? $emit('excluir') : ''"
					label="Estado Cadastral"
				/>
			</div> -->
    </div>
    <!-- Se tiver nome social o nome completo deve ficar oculto -->
    <a
      href="#"
      v-if="item.nome_social && showName"
      @click.prevent="showName = false"
      class="small"
      >Ocultar Nome de Registro <i class="fas fa-eye-slash"></i
    ></a>

    <a
      href="#"
      v-if="item.nome_social && !showName"
      @click.prevent="showName = true"
      class="small"
      >Ver Nome de Registro <i class="fas fa-eye"></i
    ></a>
    <div class="row">

      <form-input
        grid="12"
        v-model="item.nome_completo"
        :required="true"
        label="Nome Completo"
        :type="showName ? 'text' : 'password'"
      />

      <form-select
        grid="12"
        v-model="item.ind_cadastro_valido_pessoa"
        :itens="[
          { id: 1, value: 'Sim' },
          { id: 2, value: 'Não' },
          { id: 3, value: 'Não se Aplica' },
        ]"
        label="Cadastro da pessoa válido"
        placeholder="Selecione"
      />

      <form-input 
        grid="6" 
        v-model="item.nome_social" 
        label="Nome Social" 
      />

      <form-select
        grid="6"
        v-model="item.origem_nome_social"
        :itens="$root.arrays.origem_nome_social"
        label="Origem do Nome Social"
      />

      <form-input
        grid="4"
        v-model="item.data_nascimento"
        v-mask="'##/##/####'"
        label="Data nascimento"
        :required="true"
      />
      <form-input
        v-model="item.nome_curador"
        grid="8"
        label="Nome do Curador/Tutor"
      />
      <form-select
        grid="6"
        v-model="item.posicao_familiar"
        :itens="$root.arrays.posicao_familiar"
        :disabled="true"
        label="Posição familiar"
        :required="true"
      />
      <form-select
        grid="6"
        v-model="item.sexo"
        :itens="$root.arrays.sexo"
        label="Sexo"
      />
      <form-select
        grid="4"
        v-model="item.ind_identidade_genero"
        :itens="$root.arrays.pergunta"
        label="Deseja informar o gênero?"
      />
      <form-select
        v-model="item.nu_tipo_identidade_genero"
        grid="4"
        label="Gênero"
        :itens="$root.arrays.tipo_identidade_genero"
        v-if="item.ind_identidade_genero == 1"
      />
      <form-select
        v-model="item.ind_transgenero"
        grid="4"
        label="Pessoa trans ou travesti"
        :itens="$root.arrays.ind_trans"
      />
      <form-select
        grid="4"
        v-model="item.cor_raca"
        :itens="$root.arrays.cor_raca"
        label="Cor ou Raça"
      />
      <form-select
        grid="4"
        v-model="item.estado_civil"
        :itens="$root.arrays.estado_civil"
        label="Situação Conjugal?"
      />
      <form-input
        v-model="item.telefone"
        grid="4"
        v-mask="'(##) # ####-####'"
        label="Telefone"
      />
      <form-input
        v-model="item.celular"
        grid="4"
        v-mask="'(##) # ####-####'"
        label="Celular/Whatsapp"
      />
      <form-input v-model="item.email" grid="4" label="E-mail" />
      <form-input v-model="item.mae" grid="6" label="Filiação 1" />
      <form-input v-model="item.pai" grid="6" label="Filiação 2" />
      <form-input
        grid="4"
        v-model="item.pais_nascimento"
        label="País onde Nasceu"
      />
      <form-select
        grid="4"
        v-model="item.uf_nascimento"
        :itens="$root.arrays.estados"
        @change="changeMunicipios(item.uf_nascimento)"
        label="Estado onde Nasceu"
      />
      <form-select
        grid="4"
        v-model="item.municipio_nascimento"
        :itens="cidades"
        :loading="loadingMunicipios"
        label="Cidade onde Nasceu"
      />
    </div>
    <div class="row">
      <form-toggle
        grid="4"
        class="mt-4"
        v-model="item.imigrante"
        label="É imigrante ?"
      />
      <form-input
        v-if="item.imigrante"
        grid="8"
        v-model="item.pais_origem"
        label="País estrangeiro onde nasceu"
      />
      <form-toggle
        mt="1"
        v-model="item.cumprindo_pena"
        label="Usuário cumprindo pena em instituição prisional?"
      />
    </div>
    <div class="row" v-if="item.cumprindo_pena">
      <form-input grid="3" v-model="item.tempo_pena" label="Tempo da pena" />
      <form-select
        grid="3"
        v-model="item.tempo_pena_periodo"
        :itens="$root.arrays.periodo"
        label="PERÍODO"
      />
      <form-input
        grid="6"
        v-model="item.instituicao_prisional"
        label="Nome da instituição prisional"
      />
    </div>
    <div class="row pt-4 px-2 d-flex justify-content-end">
      <button @click="submit" class="btn btn-success btn-submit">
        <i class="mdi mdi-content-save"></i>
        Salvar
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      cidades: [],
      loadingMunicipios: false,
      showName: true,
    };
  },
  mounted() {
    this.changeMunicipios("all");
    this.mostrarNome();
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
    mostrarNome() {
      if(this.item.nome_social) this.showName = false;
    },
    changeMunicipios(estado) {
      this.loadingMunicipios = true;
      axios
        .get("api/dashboard/enderecos/get/cidades/" + estado)
        .then((response) => {
          this.cidades = response.data;
          this.loadingMunicipios = false;
        });
    },
  },
};
</script>
